var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3759 14.9826C12.4831 17.3896 11.6066 19.3799 10.2227 21C16.6809 17.297 15.2201 12.0511 13.6825 9.89103C12.9905 8.88812 11.1453 6.41945 9.99204 5.03082C8.42239 3.14084 8.83878 2.02214 10.4533 1.09641C4.22574 0.17066 4.4564 6.18802 4.9177 7.34522C3.30314 6.88234 2.61118 7.34522 1.91923 8.5024C3.76444 9.19671 4.22574 10.5853 2.38054 12.4368C-1.54054 16.6027 3.9951 20.0743 5.37899 21C2.79569 18.0376 4.22577 15.4455 5.60964 14.5198C6.99351 13.594 8.23907 12.1128 7.6855 9.89103C10.9146 11.974 9.06941 15.6769 8.37746 16.1398C9.99204 16.6027 10.9146 15.9084 11.3759 14.9826Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.a112affa00bc5cbb974185a3ab608f10.svg";
export { ForwardRef as ReactComponent };